/**
 * JS mobile breakpoint: the exact logical inverse of Tailwind `md` (min-width: 768px).
 * `max-width: 768px` also matched at exactly 768px (iPad Mini portrait), where `md:`
 * styles apply too, so JS laid out mobile while CSS laid out tablet (#691). A
 * `max-width: 767.98px` style complement still leaves fractional widths (767.99px)
 * matching neither query, so negate `md` instead.
 */
export const MOBILE_MEDIA_QUERY = 'not all and (min-width: 768px)';
